import { AdvancedPlannerActions } from 'src/store/actions/advancedPlannerActions';
const initialState = {
    data: [],
    workDays: null,
    rawEvents: [],
    rawEventsLoading: false,
    loading: false,
    eventLunches: {}
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case AdvancedPlannerActions.GET_ADVANCED_PLANNER_REQUEST: {
            return ({
                ...state,
                loading: true
            });
        }
        case AdvancedPlannerActions.GET_ADVANCED_PLANNER_SUCCESS: {
            return ({
                ...state,
                loading: false,
                data: payload.eventsData || [],
                workDays: payload.workDaysData || null,
                rawEvents: payload.rawEventsData || []
            });
        }
        case AdvancedPlannerActions.GET_ADVANCED_PLANNER_FAIL: {
            return ({
                ...state,
                loading: false
            });
        }
        case AdvancedPlannerActions.GET_RAW_EVENTS_REQUEST: {
            return ({
                ...state,
                rawEventsLoading: true
            });
        }
        case AdvancedPlannerActions.GET_RAW_EVENTS_SUCCESS: {
            return ({
                ...state,
                rawEventsLoading: false,
                rawEvents: payload || null
            });
        }
        case AdvancedPlannerActions.GET_RAW_EVENTS_FAIL: {
            return ({
                ...state,
                rawEventsLoading: false
            });
        }
        case AdvancedPlannerActions.GET_EVENT_LUNCHES_SUCCESS: {
            return ({
                ...state,
                eventLunches: payload || {}
            });
        }
        case AdvancedPlannerActions.GET_EVENT_LUNCHES_FAIL: {
            return ({
                ...state,
                eventLunches: {}
            });
        }
        case AdvancedPlannerActions.UPDATE_EVENT_LUNCH_SUCCESS: {
            return ({
                ...state,
                eventLunches: {
                    ...state.eventLunches,
                    [payload.eventId]: payload.lunch
                }
            });
        }
        default: return state;
    }
};
